import {Column, Row, Switch, Tooltip} from '@vidazoo/ui-kit';
import React from 'react';
import {observer} from 'mobx-react';
import {Link, useNavigate} from 'react-router-dom';
import dayjs from 'dayjs';
import UrlsService from '../../../../common/router/services/urlsService.mdl';
import MarkeredText from '../../../../common/components/markered-text/MarkeredText';
import {useScheduleReportsListContext} from '../context/ScheduleReportsListContext';
import {ReactComponent as EditIcon} from '../../../charts/list/assets/edit.svg';
import {ReactComponent as DeleteIcon} from '../../../charts/list/assets/delete.svg';
import {ReactComponent as ErrorIcon} from '../assets/rejected-status.svg';
import theme from '../view/theme.module.scss';

export default observer(function ScheduleReportsTableRow({itemIndex, style}: {itemIndex: number; style: React.CSSProperties; viewportIndex?: number}) {
    const {model} = useScheduleReportsListContext();
    const navigate = useNavigate();
    const item = model.maskItems.at(itemIndex);
    if (!item) return null;
    const background = itemIndex % 2 ? 'var(--schedule-row-odd-background)' : 'var(--schedule-row-background)';
    const rowStyle = {...style, '--table-viewport-background-color': background,
        '--table-data-column-background-color': background, '--table-column-sticky-background-color': background} as React.CSSProperties;
    const pending = model.pendingIds.includes(item._id);
    const date = (value, unix = false) => {
        if (value === undefined || value === null || value === '') return '-';
        const parsed = unix ? dayjs.unix(Number(value)) : dayjs(value);
        return parsed.isValid() ? parsed.format('MMM DD, YYYY') : '-';
    };
    return <Row index={itemIndex} style={rowStyle} data-schedule-id={item._id}>
        <Column colKey="name"><div className={theme.name}>
            {item.errorCount > 0 && <Tooltip position="right" title={`The report failed ${item.errorCount} times`}>
                <span className={theme.errorIcon} aria-label={`The report failed ${item.errorCount} times`}><ErrorIcon aria-hidden="true"/></span>
            </Tooltip>}
            <Link to={UrlsService.editScheduleReport(item._id)}><MarkeredText marker={model.getColumnSearchQuery('name')}>{item.name}</MarkeredText></Link>
        </div></Column>
        <Column colKey="schedule">{item.schedule}</Column>
        <Column colKey="dateRange">{item.dateRange}</Column>
        <Column colKey="lastSchedule">{date(item.lastSchedule, true)}</Column>
        <Column colKey="nextSchedule">{date(item.nextSchedule, true)}</Column>
        <Column colKey="created">{date(item.created)}</Column>
        <Column colKey="isActive"><Switch small aria-label={`Active ${item.name}`} checked={item.isActive}
            disabled={pending} onChange={() => model.toggleActive(item)}/></Column>
        <Column colKey="actions"><div className={theme.rowActions}>
            <button type="button" className={theme.iconAction} aria-label={`Edit ${item.name}`}
                onClick={() => navigate(UrlsService.editScheduleReport(item._id))}><EditIcon aria-hidden="true"/></button>
            <button type="button" className={theme.iconAction} aria-label={`Delete ${item.name}`} disabled={pending}
                onClick={() => {model.promptDeleteItem = item;}}><DeleteIcon aria-hidden="true"/></button>
        </div></Column>
    </Row>;
});
